<template>
  <div>
    <div
      class="alert alert-danger d-flex align-items-right"
      role="alert"
      v-if="!isCompanyUser && balance < 30000 && program.plan === 3"
    >
      <i
        class="fa fa-exclamation-triangle pr-2 text-white"
        aria-hidden="true"
      ></i>
      <div>موجودی حساب شما کم تر از 30 هزار تومان می باشد!</div>
    </div>
    <div
      class="alert alert-warning d-flex align-items-right"
      role="alert"
      v-if="program.plan === 1"
    >
      <i
        class="fa fa-exclamation-triangle pr-2 text-white"
        aria-hidden="true"
      ></i>
      <div>کاربر گرامی شما در حال استفاده از پلن رایگان می باشید!</div>
    </div>
    <div
      v-if="
        program.type === 2 &&
          (program.information.inputs === undefined ||
            program.information.inputs.length === 0)
      "
    >
      <div class="alert alert-danger" role="alert">
        برنامه فاقد ورودی می‌باشد. برای افزودن فایل و یا لینک
        <router-link
          :to="{
            name: 'programs-files',
            params: { id: program.id }
          }"
          class="alert-link"
          >کلیک
        </router-link>
        کنید.
      </div>
    </div>
    <div class="card card-custom gutter-b">
      <div class="card-header">
        <div class="card-title">
          <h3 class="card-label">
            {{ program.name }}
          </h3>
        </div>
      </div>
      <div class="card-body">
        <div class="d-flex justify-content-between py-2 mb-5">
          <div class="d-flex flex-column flex-root w-100">
            <span class="mb-2">نوع</span>
            <span class="opacity-70">
              {{ programTypes[program.type] }}
            </span>
          </div>
          <div class="d-flex flex-column flex-root w-100">
            <span class="mb-2">پلن</span>
            <span class="opacity-70">
              {{ programPlans[program.plan] }}
            </span>
          </div>
          <div v-if="program.poster" class="d-flex flex-column flex-root w-100">
            <span class="mb-2">پُستر</span>
            <span class="opacity-70" dir="ltr">
              {{ program.poster }}
            </span>
          </div>
          <div v-if="channel.id" class="d-flex flex-column flex-root w-100">
            <span class="mb-2">نمایش در کانال</span>
            <span>
              <switches
                v-model="channel_enabled"
                theme="bulma"
                color="blue"
              ></switches>
            </span>
          </div>
          <div
            v-if="isProgramStopped(program)"
            class="d-flex flex-column flex-root w-100"
          >
            <span class="mb-2">وضعیت</span>
            <span class="opacity-70 text-danger"> متوقف شده </span>
          </div>
        </div>
        <div v-if="program.type === 1">
          <div class="d-flex justify-content-between py-2 mb-5">
            <div class="d-flex flex-column flex-root w-100">
              <span class="mb-2">
                آدرس استریم‌
                <button
                  class="btn p-0"
                  @click="copyText(program.stream_url, $event)"
                >
                  <i class="far fa-1x fa-copy"></i>
                </button>
              </span>
              <span class="opacity-70" dir="ltr">
                {{ program.stream_url }}
              </span>
            </div>
          </div>
          <div class="d-flex justify-content-between py-2 mb-5">
            <div class="d-flex flex-column flex-root w-100">
              <span class="mb-2">
                کلید استریم‌
                <button
                  class="btn p-0"
                  @click="copyText(program.stream_key, $event)"
                >
                  <i class="far fa-1x fa-copy"></i>
                </button>
              </span>
              <span class="opacity-70" dir="ltr">
                {{ program.stream_key }}
              </span>
            </div>
          </div>
        </div>
        <div
          v-if="program.type === 2"
          class="d-flex justify-content-between py-2 mb-5"
        >
          <div
            v-if="
              program.information.inputs !== undefined &&
                program.information.inputs.length > 0
            "
            class="d-flex flex-column flex-root w-100"
          >
            <span class="mb-2">
              ورودی‌ها
            </span>
            <span class="opacity-70" dir="ltr">
              <span
                class="d-block overflow-hidden"
                v-for="input in program.information.inputs"
                :key="input"
              >
                <a
                  v-if="input.startsWith('http') || input.startsWith('rtmp')"
                  :href="input"
                  target="_blank"
                  class="text-nowrap"
                >
                  {{ input }}
                </a>
                <a v-else href="" @click.prevent="download(input)">
                  {{ input.split("/files/")[1] }}
                </a>
              </span>
            </span>
          </div>
        </div>
        <div
          v-if="program.public_url"
          class="d-flex justify-content-between py-2 mb-5"
        >
          <div class="d-flex flex-column flex-root w-100">
            <span class="mb-2">
              لینک نمایش
              <button
                class="btn p-0"
                @click="copyText(program.public_url, $event)"
              >
                <i class="far fa-1x fa-copy"></i>
              </button>
            </span>
            <span class="opacity-70" dir="ltr">
              <a :href="program.public_url" target="_blank">
                {{ program.public_url }}
              </a>
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { VERIFY_USER } from "@/core/services/store/profile.module";
import { GET_PROGRAM_FILE_URL } from "@/core/services/store/programs.module";
import {
  STORE_CHANNEL_PROGRAM,
  DESTROY_CHANNEL_PROGRAM,
  FETCH_CHANNEL,
  FETCH_CHANNELS
} from "@/core/services/store/channels.module";
import Swal from "sweetalert2";
import Switches from "vue-switches";

export default {
  name: "ProgramInfo",
  props: {
    program: Object
  },
  components: {
    Switches
  },
  data() {
    return {
      channel_enabled: false
    };
  },
  watch: {
    channel_enabled(val) {
      let action = val ? STORE_CHANNEL_PROGRAM : DESTROY_CHANNEL_PROGRAM;

      if (this.isInChannel !== val)
        this.$store
          .dispatch(action, {
            program: this.program.id,
            channel: this.channel.id
          })
          .then(() => {
            this.getChannels();
          });
    }
  },
  mounted() {
    this.getChannels();
    //update wallet balance
    this.$store.dispatch(VERIFY_USER).catch(e => void e);
  },
  computed: {
    ...mapGetters([
      "programTypes",
      "programPlans",
      "currentUserWallets",
      "channels",
      "channel"
    ]),
    balance() {
      if (this.currentUserWallets[0]) {
        return parseInt(this.currentUserWallets[0].balance / 10);
      }
      return 0;
    },
    isInChannel() {
      if (this.channel.id) {
        for (let i in this.channel.programs) {
          if (this.channel.programs[i].id === this.program.id) {
            return true;
          }
        }
      }
      return false;
    }
  },
  methods: {
    getChannels() {
      this.$store
        .dispatch(FETCH_CHANNELS)
        .then(() => {
          if (this.channels && this.channels[0]?.id) {
            this.getChannel();
          }
        })
        .catch(() => {
          this.loaded = true;
        });
    },
    getChannel() {
      this.$store
        .dispatch(FETCH_CHANNEL, this.channels[0]?.id)
        .then(() => {
          this.loaded = true;

          this.channel_enabled = this.isInChannel;
        })
        .catch(() => {
          this.loaded = true;
        });
    },
    download(path) {
      this.$store
        .dispatch(GET_PROGRAM_FILE_URL, {
          program: this.program.id,
          path: path
        })
        .then(url => {
          Swal.fire({
            html: `<a class="btn btn-primary btn-lg" href="${url}" target="_blank" download>دانلود</a>`,
            showCloseButton: false,
            showCancelButton: false,
            showConfirmButton: false
          });
        });
    }
  }
};
</script>
<style lang="scss">
.vue-switcher-theme--bootstrap.vue-switcher-color--primary.vue-switcher--unchecked
  div {
  background-color: #d8dbd7;

  &:after {
    background-color: #c3d1dd;
  }
}
</style>
